/**
 * Склейка трёх ног виджета ARPDAU/ARPMAU (MAU, AdMon, InApps) по периоду.
 *
 * Ноги отдают период в РАЗНОМ формате при groupBy='month': активные
 * пользователи приходят из formatDateTime(activity_period, '%Y-%m') → '2026-07',
 * а выручка — из toStartOfMonth(event_date) → '2026-07-01'. День и неделя у
 * обеих ног уже '%Y-%m-%d' и совпадают как есть.
 */

/** Приводит период любой ноги к общему ключу склейки. */
export function periodKey(period, groupBy) {
  return groupBy === 'month' ? String(period).slice(0, 7) : String(period);
}

function emptyRow(period) {
  return {
    period,
    dau: 0,
    admonAndroid: 0,
    admonIos: 0,
    inappsAndroid: 0,
    inappsIos: 0
  };
}

/**
 * Собирает сырые строки виджета: по строке на период, с разбивкой выручки
 * по платформам. Комиссии сторов и сам ARPDAU считаются поверх этого
 * результата на стороне виджета.
 *
 * @param {Object} params
 * @param {Array}  params.dauData    — activeUsersResponse.data
 * @param {Array}  params.admonData  — ответ /metrics/admon-by-period
 * @param {Array}  params.inappsData — ответ /metrics/inapps-by-period
 * @param {string} params.groupBy    — day | week | month
 * @returns {Array} строки, отсортированные по периоду
 */
export function mergeArpdauPeriods({ dauData = [], admonData = [], inappsData = [], groupBy = 'day' }) {
  const periodsMap = new Map();

  dauData.forEach(item => {
    const key = periodKey(item.period, groupBy);
    periodsMap.set(key, { ...emptyRow(key), dau: item.activeUsers || 0 });
  });

  const addRevenue = (rows, androidField, iosField) => {
    rows.forEach(item => {
      const key = periodKey(item.period, groupBy);
      if (!periodsMap.has(key)) {
        periodsMap.set(key, emptyRow(key));
      }
      const periodData = periodsMap.get(key);
      if (item.platform === 'android') {
        periodData[androidField] += item.revenue || 0;
      } else if (item.platform === 'ios') {
        periodData[iosField] += item.revenue || 0;
      }
    });
  };

  addRevenue(admonData, 'admonAndroid', 'admonIos');
  addRevenue(inappsData, 'inappsAndroid', 'inappsIos');

  return Array.from(periodsMap.values()).sort((a, b) => a.period.localeCompare(b.period));
}
